import * as Schema from "effect/Schema";

import { TrimmedNonEmptyString } from "./baseSchemas";

/**
 * `projects.listEntries`, the file listing the vendored mobile client asks for.
 *
 * Forge serves `projects.searchEntries`, which answers "which entries match this
 * query". The mobile Files screen opens with no query at all and wants "what is
 * here", so there was nothing to call and the screen showed "Files unavailable".
 *
 * The shapes mirror `packages/t3-contracts/src/project.ts`, because the mobile
 * client decodes with those. Note that Forge's own `ProjectEntry` carries an
 * extra optional `parentPath` the client's does not declare, so the handler maps
 * entries across rather than passing them through — see
 * apps/server/src/workspace/projectsCompat.ts.
 */

const ProjectEntryKind = Schema.Literals(["file", "directory"]);

export const CompatProjectEntry = Schema.Struct({
  path: TrimmedNonEmptyString,
  kind: ProjectEntryKind,
});
export type CompatProjectEntry = typeof CompatProjectEntry.Type;

export const ProjectListEntriesInput = Schema.Struct({
  cwd: TrimmedNonEmptyString,
});
export type ProjectListEntriesInput = typeof ProjectListEntriesInput.Type;

export const ProjectListEntriesResult = Schema.Struct({
  entries: Schema.Array(CompatProjectEntry),
  truncated: Schema.Boolean,
});
export type ProjectListEntriesResult = typeof ProjectListEntriesResult.Type;

export class ProjectListEntriesError extends Schema.TaggedErrorClass<ProjectListEntriesError>()(
  "ProjectListEntriesError",
  {
    message: Schema.String,
    cwd: Schema.optional(TrimmedNonEmptyString),
    cause: Schema.optional(Schema.Defect),
  },
) {}
